import React, { useRef, useState } from "react";
import DraftReviewSubmit from "./DraftProgressComp/DraftReviewSubmit";
import DraftConfirmation from "./DraftProgressComp/DraftConfirmation";
import fileIcon from "../../../asset/images/file-withbg.svg";

function DraftProgress({ selectedDraft, onBack, setActiveTab }) {

  const [step, setStep] = useState(1);
  const [uploadedData, setUploadedData] = useState(null);
  const [hasData, setHasData] = useState(true);

  return (
    <div className="new-upload">
      <div className="progress-bar draft-progress-bar">
        
        <div className={`progress-step ${step > 1 ? "completed" : ""} ${step === 1 ? "active" : ""}`}>
          <div className={`${step === 1 ? "pending-state" : ""}`}>
          <span className="circle">1</span>
          </div>
          <span className="label">Review & Submit</span>
        </div>
        <div className={`progress-line ${step > 2 ? "active" : ""}`}></div>
        <div className={`progress-step ${step > 2 ? "completed" : ""} ${step === 2 ? "active" : ""}`}>
          <div className={`${step === 2 ? "pending-state" : ""}`}>
          <span className="circle">2</span>
          </div>
          <span className="label">Confirmation</span>
        </div>
      </div>
       {step === 1 && hasData &&
      <div className="info-banner info-flex draft-banner">
          <span className="banner-text">
              <img src={fileIcon} alt="file icon" />
            <span className="bold-text">{selectedDraft?.clientName}'s</span> supporting document is pending, Upload document to submit details to the Checker.
          </span>
        </div>
      }

      <div className="wrap-all-tabs">
        
        {step === 1 && 
        <DraftReviewSubmit 
            selectedDraft={selectedDraft}
            onNext={() => setStep(2)}
            onBack={onBack}
            setUploadedData={setUploadedData}
             setHasData={setHasData}
          />}

        {step === 2 && (
          <DraftConfirmation
            onNewUpload={() => setActiveTab("admin")}
            setActiveTab={setActiveTab}
            uploadedData={uploadedData}
          />
        )}
      </div>

    </div>
  );
}

export default DraftProgress;
